// src/components/dashboard/ActiveEmployeesCard.js
// Dashboard card — live billable-employee count + net change this cycle (H2).
// Visibility gated by `set:bill:view` via src/config/dashboardCards.js.
//
// Data comes from useSubscription: `activeCount` (live counter doc) and
// `cycleStartCount` (server-stamped count at cycle start). Net change this cycle =
// activeCount − cycleStartCount; gross adds/removes need an event log (out of scope).

import { useSubscription } from "../../hooks/useSubscription";

export const ActiveEmployeesCard = ({ navigate, company }) => {
  const { activeCount, cycleStartCount } = useSubscription();

  const hasNet = activeCount != null && cycleStartCount != null;
  const net = hasNet ? activeCount - cycleStartCount : null;
  const netLabel =
    net == null
      ? null
      : net === 0
      ? "No change this cycle"
      : `${net > 0 ? "+" : "−"}${Math.abs(net)} this cycle`;
  const netColor = net == null ? "var(--ui-text-muted)" : net > 0 ? "var(--ui-success-text)" : net < 0 ? "var(--ui-danger-text)" : "var(--ui-text-muted)";

  return (
    <div className="dashboard-card">
      <div className="dashboard-card__header">
        <span className="dashboard-card__title">Active employees</span>
      </div>
      <div className="workforce__hero">
        <div className="workforce__count">{activeCount == null ? "—" : activeCount}</div>
        <div className="workforce__label">Billable employees</div>
      </div>
      {netLabel && (
        <div style={{ textAlign: "center", marginTop: 4, fontSize: "0.85rem", fontWeight: 600, color: netColor }}>
          {netLabel}
        </div>
      )}
      <div style={{ textAlign: "center", marginTop: 8, fontSize: "0.75rem", color: "var(--ui-text-faint)", lineHeight: 1.5 }}>
        Your bill is based on the highest active count during the month.
      </div>
      <div className="dashboard-card__footer">
        <a
          href="#"
          onClick={(e) => {
            e.preventDefault();
            navigate(`/company/${company.slug}/settings/subscriptions`);
          }}
          className="dashboard-card__link"
        >
          View billing →
        </a>
      </div>
    </div>
  );
};
